import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import IconActionCheckmark from '@bubble-ui/icon-action-checkmark';
import View from '@bubble-ui/primitive-view';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var TransactionCheckmark = _ref => {
  var {
    disabled,
    focused,
    hovered,
    isChecked,
    pressed
  } = _ref;
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  var {
    iconWrapper,
    overlayStyle,
    rootStyle
  } = getDefaultStyleSheet({
    designContext,
    designVersion,
    disabled,
    focused,
    hovered,
    isChecked,
    pressed
  });
  return /*#__PURE__*/React.createElement(View, {
    style: rootStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: overlayStyle
  }), /*#__PURE__*/React.createElement(View, {
    style: iconWrapper
  }, isChecked && /*#__PURE__*/React.createElement(IconActionCheckmark, {
    colorToken: "colors/text/inverse"
  })));
};
TransactionCheckmark.displayName = 'TransactionCheckmark';
export default withProvisionalOverrideFromContext(TransactionCheckmark);
//# sourceMappingURL=index.js.map